import apiClient from './client';

export async function createLinkToken() {
  const res = await apiClient.post('/api/v1/plaid/link-token');
  return res.data; // { linkToken }
}

export async function exchangePublicToken(publicToken) {
  const res = await apiClient.post('/api/v1/plaid/exchange', { publicToken });
  return res.data;
}

export async function getPlaidAccounts() {
  const res = await apiClient.get('/api/v1/plaid/accounts');
  return res.data;
}

export async function getPlaidTransactions(accountId, startDate, endDate) {
  const res = await apiClient.get(`/api/v1/plaid/accounts/${accountId}/transactions`, {
    params: { startDate, endDate },
  });
  return res.data;
}

export async function syncPlaidAccount(accountId) {
  const res = await apiClient.post(`/api/v1/plaid/accounts/${accountId}/sync`);
  return res.data;
}

export async function deletePlaidAccount(accountId) {
  return apiClient.delete(`/api/v1/plaid/accounts/${accountId}`);
}